import { observable, action, runInAction, computed } from 'mobx'
import { json, get } from '../../../utils/ajax'
import {message} from "antd";

class CarseriesStore {

    @observable list
    @observable loading
    @observable modal
    @observable editFields
    @observable forms
    @observable page
    @observable brands
    @observable btnLoading

    constructor () {
        this.list = []
        this.forms = {
            state: '',
        }
        this.loading = false
        this.btnLoading = false
        this.modal = 'hide'
        this.page = {
            current: 1,
            total: 1,
            search: ''
        }
        this.brands = []
    }

    /**
     * 获取选中卡片
     */
    @computed
    get checked () {
        return this.list.filter(item => item.checked)
    }

    /**
     * 获取为选中卡片
     */
    @computed
    get unChecked () {
        return this.list.filter(item => !item.checked)
    }

    /**
     * 点击选中
     * @param id
     */
    @action
    onImageCardChecked = (id) => {
        const list = this.list.map(item => {
            if (item.id === id) {
                item.checked = !item.checked
            }
            return item
        })
        runInAction(() => {
            this.list = list
        })
    }

    /**
     * modul取消后隐藏
     */
    @action.bound
    cancelEdit () {
        this.loading = false
        this.modal = 'hide'
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields () {
        let fields = {
            id: {value: this.forms.id},
            carSeriesCode: {value: this.forms.carSeriesCode},
            carBrandId: {value: this.forms.carBrandId},
            icon: {value: this.forms.icon},
            defaultName: {value: this.forms.defaultName},
            defaultDescription: {value: this.forms.defaultDescription},
            rank: {value: this.forms.rank}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action.bound
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id:fields.id.value,
            carSeriesCode: fields.carSeriesCode.value,
            carBrandId: fields.carBrandId.value,
            icon: fields.icon.value,
            defaultName: fields.defaultName.value,
            defaultDescription: fields.defaultDescription.value,
            rank: fields.rank.value,
        }
        this.forms = forms
    }

    /**
     * 初始化卡片列表
     * @param page
     * @returns {Promise.<void>}
     */
    @action initList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.current) {
            page = this.page.current - 1
        } else {
            page = 0
        }
        let search = this.page.search || ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries:search`, {
            'page': page.toString(),
            'search.name': search,
            'size': 15
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            res.content && (this.list = res.content.map(l => {
                return {
                    id: l.id,
                    title: l.defaultName,
                    subTitle: l.defaultDescription,
                    checked: false,
                    image: l.icon,
                    isable: l.state,
                }
            }))
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (!id) {
            runInAction(() => {
                this.loading = false
                this.modal = 'show'
                this.forms = {}
            })
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/${id}`)
            if (res && res.status === 0) {
                return
            }
            runInAction(() => {
                this.forms = res
                this.loading = false
                this.modal = 'show'
            })
        }
    }

    /**
     * 初始化品牌下拉框
     */
    @action initeBrand = async (id) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brands:search?search.state=1&&size=100`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands = res.content
        })
    }

    /**
     * 停用车系
     */
    @action disable = async () => {
        runInAction(() => {
            this.loading = true
        })
        const ids2 = this.checked.map(i => i.id)
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/disable`, ids2)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/disableCarseries`, ids2)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = this.list.map(item => {
                for (let i in ids2) {
                    if (ids2[i] === item.id) {
                        item.isable = 0
                    }
                }
                return item
            })
            this.loading = false
        })
        this.initList(0)
    }

    /**
     * 启用车系
     */
    @action enable = async () => {
        runInAction(() => {
            this.loading = true
        })
        const ids2 = this.checked.map(i => i.id)
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/enable`, ids2)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/enableCarseries`, ids2)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = this.list.map(item => {
                for (let i in ids2) {
                    if (ids2[i] === item.id) { item.isable = 1}
                }
                return item
            })
            this.loading = false
        })
        this.initList(0)
    }

    /**
     * 新增或者修改表单值
     */
    @action addCarSeries = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            // const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/add`, this.forms)
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseries/insert`, this.forms)
            if (res && res.status === 0) {
                return
            }
        } else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseries/edite`, this.forms)
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand/${this.forms.carBrandId}`)
            let carseries = {
                carseriesId : this.forms.id,
                carseriesName : this.forms.defaultName,
                carseriesImage : this.forms.icon,
                rank : this.forms.rank,
                brandName : res1.defaultName
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/updateCarseries`, carseries)
            if (res && res.status === 0) {
                return
            }
        }
        this.initList(0)
        runInAction(() => {
            this.modal = 'unShow'
            this.loading = false
        })
    }

    @action selectSameName = async (name) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries:search?size=1&&search.name=` + name)
        if (res.status === 0) {
            return
        } else {
            if (res.content[0] && res.content[0].id === this.forms.id) {
                return '0'
            }
            return res.content.length
        }
    }

    @action selectSameCode = async (code) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries:search?size=1&&search.carSeriesCode=` + code)
        if (res.status === 0) {
            return
        } else {
            if (res.content[0] && res.content[0].id === this.forms.id) {
                return 0
            }
            return res.content.length
        }
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.btnLoading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.btnLoading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.btnLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

}
export default new CarseriesStore()


// WEBPACK FOOTER //
// ./src/Backend/common/Carseries/store.js